(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticksoo-auto-links"] && !Shopify.designMode) return;
  try {
    (() => {
  const clean = value => String(value || '').trim().replace(/\s+/g, ' ');
  const key = value => clean(value).toLowerCase();
  const productLink = value => {
    const target = new URL(value, location.origin);
    if (target.origin !== location.origin) return null;
    new URL(location.href).searchParams.forEach((value, name) => {
      if (/^utm_/i.test(name) || ['gclid','fbclid','msclkid','ttclid','preview_theme_id'].includes(name)) target.searchParams.set(name, value);
    });
    target.searchParams.delete('style');
    target.searchParams.delete('variant');
    return target;
  };
  const modelOrder = value => /^iPhone Air$/i.test(value) ? 'iPhone 17' : value;
  const order = (a, b) => modelOrder(b).localeCompare(modelOrder(a), 'en', { numeric: true, sensitivity: 'base' });
  const usable = items => items.map(p => ({...p, model: clean(p.model), color: clean(p.color)})).filter(p => p.model && p.color);
  const grouped = items => {
    const groups = new Map();
    usable(items).forEach(p => {const k = key(p.model); if (!groups.has(k)) groups.set(k, []); groups.get(k).push(p);});
    return [...groups.values()].sort((a,b) => order(a[0].model,b[0].model));
  };
  const choose = (items, color, current) => {
    const same = items.filter(p => key(p.color) === key(color));
    const pool = same.length ? same : items;
    return [...pool].sort((a,b) => Number(b.url === current) - Number(a.url === current) || Number(b.available) - Number(a.available) || Number(key(b.color) === 'silver') - Number(key(a.color) === 'silver') || a.color.localeCompare(b.color) || String(a.id).localeCompare(String(b.id)))[0];
  };
  const pending = new Map();
  const load = (source, seed) => {
    if (seed && !pending.has(source)) {
      try {
        const data = JSON.parse(seed.textContent);
        if (Array.isArray(data.products) && data.products.length === data.items && data.items > 0 && usable(data.products).length === data.items) {
          pending.set(source, Promise.resolve(usable(data.products)));
        }
      } catch {}
    }
    if (!pending.has(source)) pending.set(source, (async () => {
      let records = [], pages = 1, total;
      for (let page = 1; page <= pages; page++) {
        const url = new URL(source, location.origin); url.searchParams.set('page', page);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        let data;
        try {
          const response = await fetch(url, {credentials:'same-origin', signal:controller.signal});
          if (!response.ok) throw new Error('Catalog unavailable');
          data = await response.json();
        } finally { clearTimeout(timeout); }
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 500 || data.page !== page || !Number.isInteger(data.items) || data.items < 0) throw new Error('Invalid catalog');
        if (page === 1) { pages = Math.max(1, data.pages); total = data.items; }
        else if (Math.max(1, data.pages) !== pages || data.items !== total) throw new Error('Catalog changed');
        records.push(...data.products);
      }
      const unique = [...new Map(records.map(p => [p.id,p])).values()];
      if (unique.length !== total) throw new Error('Incomplete catalog');
      return usable(unique);
    })().catch(error => {pending.delete(source); throw error;}));
    return pending.get(source);
  };
  class AutoLinks extends HTMLElement {
    connectedCallback() {
      if (this.started) return; this.started = true;
      this.select = this.querySelector('select'); this.status = this.querySelector('[role=status]');
      this.querySelector('.ss-auto-retry').addEventListener('click', () => this.start());
      this.select.addEventListener('change', () => this.change()); this.start();
    }
    async start() {
      this.querySelector('.ss-auto-retry').hidden = true;
      this.select.disabled = true; this.select.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      try {
        const items = (await load(this.dataset.source, this.querySelector('[data-ss-catalog-seed]') || this.closest('product-info')?.querySelector('[data-ss-catalog-seed]'))).filter(item => key(item.family) === key(this.dataset.family));
        if (!this.isConnected) return;
        if (!items.length || (this.dataset.mode !== 'directory' && !items.some(item => key(item.model) === key(this.dataset.model)))) throw new Error('No matching models');
        this.items = items;
        this.render(); this.status.textContent=''; this.select.disabled=false; this.select.removeAttribute('aria-busy');this.dispatchEvent(new CustomEvent('ss:auto-links-ready'));
      }
      catch {this.status.textContent=this.querySelector('[data-error]').textContent; this.querySelector('.ss-auto-retry').hidden=false;this.select.removeAttribute('aria-busy');}
    }
    option(title,value,selected,parent=this.select) {const o = new Option(title,value,false,selected);parent.append(o);}
    render() {
      this.select.replaceChildren();const mode=this.dataset.mode;
      if (mode==='directory') {
        const requested = new URL(location.href).searchParams.get('model') || '';
        this.option(this.querySelector('[data-all]').textContent,'',!requested);
        grouped(this.items).forEach(group => this.option(group[0].model,group[0].model,key(requested)===key(group[0].model)));
        this.cards();return;
      }
      const groups=mode==='color'?[this.items.filter(p=>key(p.model)===key(this.dataset.model))]:grouped(this.items);
      if(mode==='color') {
        const colors=[...new Set(groups[0].map(p=>key(p.color)))];
        colors.forEach(color=>{const p=choose(groups[0].filter(p=>key(p.color)===color),color,this.dataset.current);this.option(p.color+(p.available?'':' — '+this.dataset.unavailable),p.url,p.url===this.dataset.current);});
        this.colorButtons(groups[0]);
      } else {
        const series=new Map();
        groups.forEach(group=>{const p=choose(group,this.dataset.color,this.dataset.current);const match=p.model.match(/^iPhone\s+(\d+)/i);const samsung=p.model.match(/^Samsung Galaxy (S\d+)/i);const google=p.model.match(/^Google Pixel (\d+)/i);const label=/^iPhone Air$/i.test(p.model)?'iPhone 17':match?'iPhone '+match[1]:samsung?'Samsung Galaxy '+samsung[1]:google?'Google Pixel '+google[1]:p.model;
          if(!series.has(label)){const opt=document.createElement('optgroup');opt.label=label;series.set(label,opt);this.select.append(opt);}
          this.option(p.model+(p.available?'':' — '+this.dataset.unavailable),p.url,key(p.model)===key(this.dataset.model),series.get(label));
        });
      }
    }
    colorButtons(items) {
      const grid=this.querySelector('.ss-phone-colors');
      if(!grid)return;
      const tones={'cosmic orange':'#e98645','deep blue':'#344458','silver':'#e1e2df','black':'#343536','burgundy':'#70414c','glacier':'#bfd5e4','lavender':'#c6bddb','mist blue':'#bdc9db','sage':'#b8c4ae','white':'#f4f2eb','purple':'#b5a5ce','blue':'#839ab5','gold':'#d8c8a3','green':'#8caa83','gray':'#d3d0c9','pink':'#d5a4cf','magenta':'#a23764'};
      const modelTones={
        'iphone air':{'space black':'#3c3c3d','cloud white':'#f2f1ec','sky blue':'#c8dce9','light gold':'#e9dfc8'},
        'iphone 15':{'black':'#3c4042','blue':'#d5e3e8','green':'#cfdcc8','pink':'#efd4d2','yellow':'#ece6c6'},
        'iphone 16':{'black':'#35383a','white':'#f4f3ef','pink':'#e8a0c1','teal':'#9bbcb5','ultramarine':'#8f9eed'}
      };
      const titaniumTones={'black titanium':'#454749','blue titanium':'#515d6c','natural titanium':'#b5afa3','white titanium':'#f0eee8','desert titanium':'#c9b29c'};
      const ns='http://www.w3.org/2000/svg';
      const shape=(name,attrs)=>{const el=document.createElementNS(ns,name);Object.entries(attrs).forEach(([k,v])=>el.setAttribute(k,v));return el;};
      grid.replaceChildren();
      [...this.select.options].forEach(option=>{
        const p=items.find(item=>item.url===option.value),target=productLink(option.value);
        if(!p||!target)return;
        const link=document.createElement('a');link.className='ss-phone-color';link.href=target.href;
        link.setAttribute('aria-label',p.color+(p.available?'':' — '+this.dataset.unavailable));
        if(p.url===this.dataset.current)link.setAttribute('aria-current','page');
        const modelKey=key(p.model).replace(/ plus$/, '');
        const tone=modelTones[modelKey]?.[key(p.color)]||titaniumTones[key(p.color)]||tones[key(p.color)]||'#c6c6c6';
        const icon=shape('svg',{viewBox:'0 0 30 46','aria-hidden':'true',focusable:'false'});
        icon.append(shape('rect',{x:1,y:1,width:28,height:44,rx:6,fill:tone,stroke:'#000', 'stroke-opacity':'.2','stroke-width':1}));
        if (/^Samsung/i.test(p.model)) {
          const lenses = /ultra/i.test(p.model) ? [[7,7],[7,14],[7,21],[15,7],[15,14]] : [[7,7],[7,14],[7,21]];
          lenses.forEach(([cx,cy])=>icon.append(shape('circle',{cx,cy,r:2.3,fill:'#24272c',stroke:'#fff','stroke-opacity':'.45','stroke-width':'.5'})));
          icon.append(shape('circle',{cx:15,cy:/ultra/i.test(p.model)?21:7,r:1,fill:'#f4f0dd'}));
        } else if (/^iPhone Air$/i.test(p.model)) {
          icon.append(shape('rect',{x:3,y:3,width:24,height:12,rx:5,fill:'#fff','fill-opacity':'.13',stroke:'#000','stroke-opacity':'.12'}));
          icon.append(shape('circle',{cx:8,cy:9,r:3.2,fill:'#24272c',stroke:'#fff','stroke-opacity':'.45','stroke-width':'.5'}));
          icon.append(shape('circle',{cx:23,cy:9,r:1.2,fill:'#f4f0dd'}));
        } else if (/^Google Pixel/i.test(p.model)) {
          icon.append(shape('rect',{x:3,y:6,width:24,height:10,rx:5,fill:'#24272c',stroke:'#fff','stroke-opacity':'.45','stroke-width':'.6'}));
          [8,14,20].forEach(cx=>icon.append(shape('circle',{cx,cy:11,r:2.1,fill:'#46515b',stroke:'#96a1a9','stroke-width':'.6'})));
          icon.append(shape('circle',{cx:25,cy:11,r:1,fill:'#f4f0dd'}));
        } else {
        icon.append(shape('rect',{x:3,y:3,width:/pro/i.test(p.model)?24:10,height:13,rx:4,fill:'#fff','fill-opacity':'.13',stroke:'#000','stroke-opacity':'.12'}));
        const lenses=/pro/i.test(p.model)?[[7,7],[7,12],[12,9.5]]:[[7,7],[7,12]];
        lenses.forEach(([cx,cy])=>icon.append(shape('circle',{cx,cy,r:2.1,fill:'#24272c',stroke:'#fff','stroke-opacity':'.45','stroke-width':'.5'})));
        icon.append(shape('circle',{cx:/pro/i.test(p.model)?23:16,cy:7,r:1,fill:'#f4f0dd'}));
        }
        const name=document.createElement('span');name.className='ss-phone-color__name';name.textContent=p.color;
        link.append(icon,name);
        if(!p.available){const stock=document.createElement('span');stock.className='ss-phone-color__stock';stock.textContent=this.dataset.unavailable;link.append(stock);}
        link.addEventListener('click',event=>{
          if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
          event.preventDefault();this.select.value=p.url;this.change();
        });
        grid.append(link);
      });
      grid.hidden=!grid.childElementCount;
      this.classList.toggle('has-color-buttons',grid.childElementCount>0);
    }
    change() {
      if(this.dataset.mode==='directory'){const url=new URL(location.href);if(this.select.value)url.searchParams.set('model',this.select.value);else url.searchParams.delete('model');history.replaceState(null,'',url);this.cards();return;}
      if(!this.select.value||(this.select.value===this.dataset.current&&!window.ssProductSwitch?.busy))return;
      const target=productLink(this.select.value);if(!target)return;
      location.assign(target.href);
    }
    cards() {
      const grid=this.querySelector('.ss-auto-grid');grid.replaceChildren();
      const selected=key(this.select.value);
      this.items.filter(p=>!selected||key(p.model)===selected).forEach(p=>{
        const target=productLink(p.url);if(!target)return;
        const a=document.createElement('a');a.href=target.href;
        if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.width=600;img.height=600;img.loading='lazy';a.append(img);}
        const title=document.createElement('h3');title.textContent=p.title.replace(/\s*\|\s*STI(?:C)?KSOO\s*$/i,'');
        const price=document.createElement('p');price.textContent=p.price;a.append(title,price);grid.append(a);
      });
    }
  }
  if(!customElements.get('ss-auto-links'))customElements.define('ss-auto-links',AutoLinks);
  window.addEventListener('pageshow', () => {
    setTimeout(() => {
      document.querySelectorAll('ss-auto-links').forEach(element => {
        if (element.items) element.render();
      });
    }, 0);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-cart-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-cart-layout')) {
    customElements.define('ss-cart-layout', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.ss-cart-items-scroll');
        this.more = this.querySelector('.ss-cart-scroll-more');
        if (!this.scroller || !this.more) return;
        this.update = () => {
          this.more.hidden = this.scroller.scrollHeight - this.scroller.clientHeight - this.scroller.scrollTop < 12;
        };
        this.advance = () => this.scroller.scrollBy({ top: this.scroller.clientHeight * .7, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.more.addEventListener('click', this.advance);
        this.scroller.addEventListener('scroll', this.update, { passive: true });
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.scroller);
        for (const child of this.scroller.children) this.resize.observe(child);
        this.update();
      }
      disconnectedCallback() {
        this.resize?.disconnect();
        this.more?.removeEventListener('click', this.advance);
        this.scroller?.removeEventListener('scroll', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-case-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('.ss-case-picker select[data-case-model]')) return;
  const option = select.selectedOptions[0];
  if (!option?.dataset.caseUrl) return;
  event.stopImmediatePropagation();
  const picker = select.closest('variant-picker');
  const colour = picker.querySelector('[data-option-slug="color"] input:checked')?.value;
  let variants;
  try { variants = JSON.parse(option.dataset.caseVariants); } catch { location.assign(option.dataset.caseUrl); return; }
  const variant = variants.find(item => item.option2 === colour) || variants.find(item => item.available) || variants[0];
  const target = new URL(option.dataset.caseUrl, location.origin);
  if (variant) target.searchParams.set('variant', variant.id);
  const navigation = new CustomEvent('ss:product-navigate', {
    bubbles: true,
    cancelable: true,
    detail: {url: target.href, productId: option.dataset.caseProductId, focusMode: 'model'}
  });
  if (select.dispatchEvent(navigation)) location.assign(target.href);
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-navigation-fit"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const initialize = (scope = document) => {
      scope.querySelectorAll('header[data-ss-fit-navigation]').forEach((header) => {
        if (header.dataset.ssFitReady) return;
        header.dataset.ssFitReady = 'true';
        const menus = [...header.querySelectorAll(':scope > .header__navigation > .header__menu')];
        let frame = 0;
        const fit = () => {
          frame = 0;
          if (!header.isConnected || !desktop.matches) return;
          menus.forEach((menu) => {
            const list = menu.querySelector(':scope > ul');
            const first = list?.querySelector('.menu__item');
            const available = menu.clientWidth - 2;
            if (!first || available <= 0) return;
            menu.style.removeProperty('--ss-nav-font');
            const base = parseFloat(getComputedStyle(first).fontSize);
            let font = base;
            const apply = (compact) => {
              menu.style.setProperty('--ss-nav-font', font + 'px');
              menu.style.setProperty('--ss-nav-padding', '0px');
              menu.style.setProperty('--ss-nav-gap', compact ? '12px' : '24px');
              menu.style.setProperty('--ss-nav-icon-gap', compact ? '3px' : '6px');
            };
            apply(false);
            if (list.getBoundingClientRect().width <= available) return;
            apply(true);
            for (let pass = 0; pass < 5; pass += 1) {
              const width = list.getBoundingClientRect().width;
              if (width <= available + 0.5) break;
              font = Math.max(13, font * ((available - 2) / width));
              apply(true);
            }
          });
        };
        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(fit);
        };
        const resize = new ResizeObserver(schedule);
        menus.forEach((menu) => resize.observe(menu));
        const changes = new MutationObserver(schedule);
        menus.forEach((menu) => changes.observe(menu, { childList: true, subtree: true, characterData: true }));
        desktop.addEventListener('change', schedule);
        document.fonts.ready.then(schedule);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(header)) {
            resize.disconnect();
            changes.disconnect();
            desktop.removeEventListener('change', schedule);
            cancelAnimationFrame(frame);
          }
        });
        schedule();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-product-lines"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ss-product-lines')) return;
  const normalize = value => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  const pending = new Map();
  const productUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      url.searchParams.delete('variant');
      url.searchParams.delete('style');
      return url;
    } catch { return null; }
  };
  const destinationProduct = (items, model, color) => {
    const score = item => {
      const itemModel = normalize(item.model), itemColor = normalize(item.color);
      const modelRank = itemModel === model ? 0 : itemModel === 'iphone 17 pro' ? 100 : itemModel === 'iphone 18 pro' ? 200 : 300;
      return modelRank + (color && itemColor !== color ? 10 : 0) + (item.available ? 0 : 2) + (itemColor === 'silver' ? 0 : 1);
    };
    return items.filter(item => productUrl(item.url)).sort((a, b) => score(a) - score(b))[0];
  };
  const load = source => {
    if (!pending.has(source)) {
      const task = (async () => {
        let records = [], pages = 1, total;
        for (let page = 1; page <= pages; page++) {
          const url = new URL(source, location.origin);
          url.searchParams.set('page', page);
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 12000);
          let data;
          try {
            const response = await fetch(url, {credentials:'same-origin', signal:controller.signal});
            if (!response.ok) throw new Error('Catalog unavailable');
            data = await response.json();
          } finally { clearTimeout(timeout); }
          if (!Array.isArray(data.products) || data.page !== page || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 500 || !Number.isInteger(data.items) || data.items < 0) throw new Error('Invalid catalog');
          if (page === 1) { pages = Math.max(1, data.pages); total = data.items; }
          else if (Math.max(1, data.pages) !== pages || data.items !== total) throw new Error('Catalog changed');
          records.push(...data.products);
        }
        const unique = [...new Map(records.map(item => [String(item.id), item])).values()];
        if (unique.length !== total) throw new Error('Incomplete catalog');
        return unique;
      })().catch(error => { pending.delete(source); throw error; });
      pending.set(source, task);
    }
    return pending.get(source);
  };
  class ProductLines extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const model = normalize(this.dataset.model), color = normalize(this.dataset.color);
      if (!model) return;
      this.querySelectorAll('a[data-catalog]').forEach(async link => {
        try {
          const items = await load(link.dataset.catalog);
          if (!this.isConnected || !link.isConnected) return;
          const candidate = destinationProduct(items, model, color);
          const target = candidate && productUrl(candidate.url);
          if (!target) return;
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) target.searchParams.set('preview_theme_id', preview);
          link.href = target.href;
        } catch { }
      });
    }
  }
  customElements.define('ss-product-lines', ProductLines);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-product-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-ss-review-link]')) return;
  const reviews = document.getElementById('judgeme_product_reviews');
  if (reviews) {
    reviews.scrollIntoView({ behavior: 'auto', block: 'start' });
    const heading = reviews.querySelector('h2');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-product-switch"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ssProductSwitch) return;
  const main = document.getElementById('MainContent');
  if (!main?.querySelector('[data-ss-product-page]')) return;
  const productPath = url => /\/products\/[^/]+\/?$/.test(url.pathname);
  const path = url => decodeURIComponent(new URL(url, location.origin).pathname).replace(/\/$/, '');
  const currentInfo = () => main.querySelector('product-info[data-update-url="true"]');
  const settings = () => JSON.parse(main.querySelector('[data-ss-product-page]').textContent);
  let displayedUrl = new URL(location.href);
  let active = null;
  let locked = [];
  let noticeTimer;
  const loadedScripts = new Set([...document.scripts].filter(s => s.src).map(s => s.src));
  const panel = document.createElement('div');
  panel.className = 'ss-product-switch-status';
  panel.hidden = true;
  const message = document.createElement('p');
  message.setAttribute('role', 'status');
  message.setAttribute('aria-live', 'polite');
  const actions = document.createElement('div');
  actions.className = 'ss-product-switch-actions';
  const retry = document.createElement('button');
  retry.type = 'button';
  const open = document.createElement('a');
  const back = document.createElement('a');
  actions.append(retry, open, back);
  panel.append(message, actions);
  main.before(panel);

  const notify = (text, error = false) => {
    clearTimeout(noticeTimer); message.textContent = error ? text : ''; panel.hidden = !error;
    
    actions.hidden = !error;
    
  };
  const lock = () => {
    main.classList.add('ss-product-switch-loading', 'ss-product-switch-blocked');
    main.setAttribute('aria-busy', 'true');
    if (!locked.length) {
      locked = [...main.querySelectorAll('form[action*="/cart/add"],product-sticky-form,.shopify-payment-button,shopify-accelerated-checkout,variant-picker,ss-style-preview')].map(element => [element, element.inert]);
      locked.forEach(([element]) => { element.inert = true; });
    }
    main.querySelectorAll('product-info').forEach(info => info.renderAbortController?.abort());
    main.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
  };
  const unlock = () => {
    locked.forEach(([element, inert]) => { if (element.isConnected) element.inert = inert; });
    locked = [];
    main.classList.remove('ss-product-switch-loading', 'ss-product-switch-blocked');
    main.removeAttribute('aria-busy');
  };
  const blockPurchase = event => {
    if (locked.length && main.contains(event.target) && (event.type === 'submit' || event.target.closest?.('form[action*="/cart/add"],product-sticky-form,.shopify-payment-button,shopify-accelerated-checkout'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  document.addEventListener('submit', blockPurchase, true);
  document.addEventListener('click', blockPurchase, true);

  const readPage = (html, target, expectedId) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.getElementById('MainContent');
    const dataNode = content?.querySelector('[data-ss-product-page]');
    const info = content?.querySelector('product-info[data-update-url="true"]');
    if (!dataNode || !info) throw new Error('Missing product page');
    const data = JSON.parse(dataNode.textContent);
    const form = doc.getElementById(info.getAttribute('form'));
    const variant = form?.querySelector('[name="id"]')?.value;
    const selected = JSON.parse(info.querySelector('[data-selected-variant]')?.textContent || 'null');
    if (String(data.id) !== info.dataset.productId || (expectedId && String(data.id) !== String(expectedId)) || path(data.url) !== path(target) || !content.contains(form) || !data.variants.map(String).includes(String(variant)) || String(selected?.id) !== String(variant)) throw new Error('Product selection mismatch');
    for (const script of content.querySelectorAll('script')) {
      if (['application/json', 'application/ld+json'].includes(script.type)) continue;
      if (script.src && !loadedScripts.has(new URL(script.getAttribute('src'), location.origin).href)) throw new Error('Product requires a full page');
      if (!script.src && script.textContent.trim()) throw new Error('Product requires initialization');
      script.remove();
    }
    return {doc, content, data, variant};
  };
  const updateHead = doc => {
    document.title = doc.title;
    const selectors = ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property^="og:"]', 'meta[property^="product:"]', 'meta[name^="twitter:"]'];
    selectors.forEach(selector => {
      document.head.querySelectorAll(selector).forEach(node => node.remove());
      doc.head.querySelectorAll(selector).forEach(node => document.head.append(document.importNode(node, true)));
    });
    const analyticsSource = [...doc.scripts].find(script => script.textContent.includes('window.ShopifyAnalytics.meta[attr] = meta[attr]'));
    const analyticsJson = analyticsSource?.textContent.match(/var meta = (\{[^\n]+\});/);
    if (analyticsJson && window.ShopifyAnalytics?.meta) {
      try {
        const meta = JSON.parse(analyticsJson[1]);
        if (String(meta.product?.id) === String(settings().id)) {
          window.ShopifyAnalytics.meta.product = meta.product;
          window.ShopifyAnalytics.meta.page = meta.page;
        }
      } catch {}
    }
  };
  const remember = productId => {
    try {
      const key = `${window.theme.settings.themeName}:recently-viewed`;
      const previous = JSON.parse(localStorage.getItem(key) || '[]');
      localStorage.setItem(key, JSON.stringify([Number(productId), ...previous.filter(id => String(id) !== String(productId))].slice(0, 50)));
    } catch {}
  };
  const savePosition = () => {
    if (!active && !locked.length) history.replaceState({...history.state, ssProductScroll: window.scrollY}, '', location.href);
  };
  let positionTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(positionTimer);
    positionTimer = setTimeout(savePosition, 120);
  }, {passive:true});
  document.addEventListener('variant:change', event => {
    if (main.contains(event.target)) savePosition();
  });
  const navigate = async (value, options = {}) => {
    const target = new URL(value, location.origin);
    if (target.origin !== location.origin || !productPath(target)) return false;
    const config = settings();
    if (!options.history) {
      displayedUrl = new URL(location.href);
      savePosition();
    }
    active?.controller.abort();
    const controller = new AbortController();
    const operation = {controller, target, options};
    active = operation;
    const focusMode = options.focusMode || 'model';
    const anchor = main.querySelector(`ss-auto-links[data-mode="${focusMode}"] .ss-phone-color[aria-current="page"]`) || main.querySelector(`ss-auto-links[data-mode="${focusMode}"] select`);
    const anchorTop = anchor?.getBoundingClientRect().top;
    const scrollY = window.scrollY;
    const touchDevice = navigator.maxTouchPoints > 0 || window.matchMedia('(any-pointer: coarse)').matches;
    if (touchDevice) anchor?.blur();
    lock();
    notify(config.loading);
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(target.href, {credentials:'same-origin', signal:controller.signal, headers:{Accept:'text/html'}});
      if (!response.ok || new URL(response.url || target.href).origin !== location.origin) throw new Error('Product unavailable');
      const page = readPage(await response.text(), target, options.productId);
      if (controller.signal.aborted || active !== operation) return true;
      const nodes = [...page.content.childNodes].map(node => document.importNode(node, true));
      if (!options.history) history.pushState({ssProductScroll:scrollY}, '', target.href);
      main.replaceChildren(...nodes);
      displayedUrl = new URL(target.href);
      unlock();
      updateHead(page.doc);
      remember(page.data.id);
      document.dispatchEvent(new CustomEvent('ss:product-loaded', {detail:{productId:page.data.id, url:target.href, restore:true}}));
      try { window.Shopify?.PaymentButton?.init?.(); }
      catch (error) { console.warn('STICKSOO accelerated checkout could not initialize.', error); }
      const currentSelector = main.querySelector(`ss-auto-links[data-mode="${focusMode}"]`);
      const currentAnchor = currentSelector?.querySelector('.ss-phone-color[aria-current="page"]') || currentSelector?.querySelector('select');
      const desiredY = options.history ? (options.scrollY ?? 0) : currentAnchor && Number.isFinite(anchorTop) ? window.scrollY + currentAnchor.getBoundingClientRect().top - anchorTop : scrollY;
      window.scrollTo({top:Math.max(0, desiredY), behavior:'instant'});
      if (!options.history && currentAnchor && !touchDevice) {
        const focus = () => { const control = currentSelector?.querySelector('.ss-phone-color[aria-current="page"]') || currentAnchor; if (control.isConnected) control.focus({preventScroll:true}); };
        if (currentAnchor.disabled) currentAnchor.closest('ss-auto-links').addEventListener('ss:auto-links-ready', focus, {once:true});
        else focus();
      }
      active = null;
      notify(options.history ? config.ready : config.reset);
      noticeTimer = setTimeout(() => { panel.hidden = true; }, 5500);
      document.dispatchEvent(new CustomEvent('ss:product-switch-complete', {detail:{productId:page.data.id, variantId:page.variant, url:target.href}}));
    } catch (error) {
      if (active !== operation) return true;
      active = null;
      if (options.history) location.replace(target.href);
      else location.assign(target.href);
    } finally {
      clearTimeout(timeout);
    }
    return true;
  };
  document.addEventListener('ss:product-navigate', event => {
    if (!main.contains(event.target) || !event.detail?.url) return;
    const target = new URL(event.detail.url, location.origin);
    if (target.origin !== location.origin || !productPath(target)) return;
    event.preventDefault();
    navigate(target.href, event.detail);
  });
  window.addEventListener('popstate', event => {
    const target = new URL(location.href);
    if (!productPath(target)) return;
    navigate(target.href, {history:true, scrollY:event.state?.ssProductScroll ?? 0});
  });
  window.ssProductSwitch = {navigate, get busy() { return Boolean(active || locked.length); }};
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-real-details"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ss-real-details')){
  customElements.define('ss-real-details',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.track=this.querySelector('.ss-real-track');
      this.buttons=[...this.querySelectorAll('button[data-step]')];
      this.update=()=>{
        const max=this.track.scrollWidth-this.track.clientWidth;
        this.buttons[0].disabled=this.track.scrollLeft<=2;
        this.buttons[1].disabled=this.track.scrollLeft>=max-2;
      };
      this.buttons.forEach(button=>button.addEventListener('click',()=>{
        const step=this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({left:step*Number(button.dataset.step),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      this.track.addEventListener('scroll',this.update,{passive:true});
      this.observer=new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.track?.removeEventListener('scroll',this.update);this.ready=false;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-style-navigation-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  const allowed = ['solids', 'textures', 'other'];
  const getStyle = () => new URLSearchParams(location.hash.slice(1)).get('skin-style');
  const applyLink = link => {
    const style = getStyle();
    if (!allowed.includes(style) || !link || !link.closest('#MainContent') || link.hasAttribute('data-design')) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/(products\/phone-skin-|collections\/phone-skins)/.test(url.pathname) || url.searchParams.has('variant')) return;
    if (url.hash && !url.hash.startsWith('#skin-style=')) return;
    url.hash = 'skin-style=' + style;
    link.href = url.pathname + url.search + url.hash;
  };
  const updateLinks = () => document.querySelectorAll('#MainContent a[href]').forEach(applyLink);
  updateLinks();
  document.addEventListener('pointerdown', event => applyLink(event.target.closest('a[href]')), {capture:true, passive:true});
  document.addEventListener('focusin', event => applyLink(event.target.closest('a[href]')));
  document.addEventListener('click', event => applyLink(event.target.closest('a[href]')), true);
  window.addEventListener('hashchange', () => {
    updateLinks();
    const style = getStyle();
    document.querySelectorAll('ss-mix-picker[data-ready]').forEach(picker => {
      if (allowed.includes(style) && picker.groupTabs?.some(tab => tab.dataset.designTab === style)) picker.activateGroup(style);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-style-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('ss-style-preview')) return;
  customElements.define('ss-style-preview',class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      this.info=this.closest('product-info');
      this.variants=JSON.parse(this.querySelector('[data-preview-variants]').textContent);
      this.previewVariants=this.variants.filter(variant=>variant.url);
      this.dialog=this.querySelector('dialog');
      this.slides=this.querySelector('[data-slides]');
      this.frame=this.querySelector('.ss-style-large-frame');
      this.options=this.querySelector('.ss-style-dialog-options');
      this.controller=new AbortController();
      const listen={signal:this.controller.signal};
      this.slideVariants=this.previewVariants.length>1?[this.previewVariants.at(-1),...this.previewVariants,this.previewVariants[0]]:[...this.previewVariants];
      this.panels=this.slideVariants.map(variant=>{
        const panel=document.createElement('div');
        panel.className='ss-style-slide';
        panel.setAttribute('aria-hidden','true');
        panel.setAttribute('aria-busy','true');
        const img=document.createElement('img');
        img.width=1600;
        img.height=1600;
        img.draggable=false;
        img.decoding='async';
        img.alt=this.dataset.title+' — '+variant.title;
        const ready=()=>panel.setAttribute('aria-busy','false');
        img.addEventListener('load',ready,listen);
        img.addEventListener('error',ready,listen);
        panel.append(img);
        return panel;
      });
      this.slides.replaceChildren(...this.panels);
      this.slides.addEventListener('scroll',()=>{
        this.prepareImages(this.slideIndex());
        this.scheduleSettle();
      },{...listen,passive:true});
      this.slides.addEventListener('scrollend',()=>this.settleSlide(),listen);
      this.slides.addEventListener('touchstart',()=>{this.touching=true;}, {...listen,passive:true});
      const endTouch=()=>{this.touching=false;this.scheduleSettle();};
      this.slides.addEventListener('touchend',endTouch,{...listen,passive:true});
      this.slides.addEventListener('touchcancel',endTouch,{...listen,passive:true});
      this.querySelector('[data-open]').addEventListener('click',()=>this.openVariant(this.currentVariant),listen);
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),listen);
      this.querySelectorAll('[data-step]').forEach(button=>{
        button.hidden=this.previewVariants.length<2;
        button.addEventListener('click',()=>this.stepVariant(Number(button.dataset.step)),listen);
      });
      this.dialog.addEventListener('keydown',event=>{
        if(event.key==='ArrowLeft' || event.key==='ArrowRight'){
          event.preventDefault();
          this.stepVariant(event.key==='ArrowRight'?1:-1);
        }
      },listen);
      this.slides.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse' || !event.isPrimary || event.button!==0)return;
        this.gesture={id:event.pointerId,x:event.clientX,left:this.slides.scrollLeft,index:this.slideIndex()};
        this.slides.setPointerCapture(event.pointerId);
        this.frame.classList.add('is-dragging');
      },listen);
      this.slides.addEventListener('pointermove',event=>{
        if(!this.gesture || event.pointerId!==this.gesture.id)return;
        this.slides.scrollLeft=this.gesture.left-(event.clientX-this.gesture.x);
      },listen);
      this.slides.addEventListener('pointerup',event=>{
        const start=this.gesture;
        if(!start || event.pointerId!==start.id)return;
        const dx=event.clientX-start.x;
        const index=start.index+(Math.abs(dx)>Math.max(35,this.slides.clientWidth*.18)?(dx<0?1:-1):0);
        this.resetGesture();
        this.goToSlide(index,true);
      },listen);
      this.slides.addEventListener('pointercancel',()=>{
        if(!this.gesture)return;
        const index=this.gesture.index;
        this.resetGesture();
        this.goToSlide(index,true);
      },listen);
      this.resizeObserver=new ResizeObserver(()=>{
        const width=this.slides.clientWidth;
        if(width===this.slideWidth)return;
        this.alignSlides();
      });
      this.resizeObserver.observe(this.frame);
      this.dialog.addEventListener('pointerdown',event=>{
        const box=this.dialog.getBoundingClientRect();
        this.backdropPress=event.target===this.dialog && (event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom);
      },listen);
      this.dialog.addEventListener('click',event=>{
        if(event.target===this.dialog && this.backdropPress)this.dialog.close();
        this.backdropPress=false;
      },listen);
      this.dialog.addEventListener('close',()=>{
        this.resetGesture();
        this.touching=false;
        clearTimeout(this.settleTimer);
        document.documentElement.classList.remove('ss-sku-preview-open');
        this.selectedControl()?.focus({preventScroll:true});
      },listen);
      this.info?.addEventListener('click',event=>{
        const input=event.target.closest?.('variant-picker input[type="radio"][data-option-value-id]');
        if(!input || input.disabled)return;
        const variant=this.variantFromPicker();
        if(variant)this.openVariant(variant);
      },listen);
      this.info?.addEventListener('change',event=>{
        if(event.target.matches?.('variant-picker select'))this.openVariant(this.variantFromPicker());
      },listen);
      this.querySelector('.ss-style-dialog-options').addEventListener('click',event=>{
        const button=event.target.closest('[data-preview-variant]');
        if(!button)return;
        const variant=this.variants.find(item=>String(item.id)===button.dataset.previewVariant);
        this.selectVariant(variant);
      },listen);
      this.setVariant(this.variants.find(variant=>String(variant.id)===this.dataset.selected));
      customElements.whenDefined('product-info').then(()=>{
        if(!this.isConnected || listen.signal.aborted)return;
        this.unsubscribe=theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange,({data})=>{
          if(String(data.productId)!==this.dataset.product || data.sectionId!==this.info?.getAttribute('data-section-id'))return;
          const variant=this.variants.find(item=>String(item.id)===String(data.variant?.id));
          if(variant && String(this.variantFromPicker()?.id)===String(variant.id))this.setVariant(variant);
        });
      });
    }
    variantFromPicker() {
      const values=Array.from(this.info?.querySelectorAll('variant-picker select, variant-picker fieldset')||[]).map(group=>group.tagName==='SELECT'?group.value:group.querySelector('input:checked')?.value);
      return this.variants.find(variant=>values.length===variant.options.length && values.every((value,index)=>value===variant.options[index]));
    }
    selectedControl() {
      return this.info?.querySelector('variant-picker input:checked, variant-picker select');
    }
    resetGesture() {
      this.gesture=null;
      this.frame.classList.remove('is-dragging');
    }
    slideIndex() {
      return this.panels.reduce((nearest,panel,index)=>Math.abs(panel.offsetLeft-this.slides.scrollLeft)<Math.abs(this.panels[nearest].offsetLeft-this.slides.scrollLeft)?index:nearest,0);
    }
    prepareImages(index) {
      for(let i=Math.max(0,index-2);i<=Math.min(this.panels.length-1,index+2);i++){
        const img=this.panels[i].querySelector('img');
        if(!img.getAttribute('src'))img.src=this.slideVariants[i].url;
      }
    }
    goToSlide(index,animate) {
      index=Math.max(0,Math.min(this.panels.length-1,index));
      this.prepareImages(index);
      this.slides.scrollTo({left:this.panels[index]?.offsetLeft||0,behavior:animate && !matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
      this.scheduleSettle();
    }
    showSlide(variant,animate) {
      const index=this.previewVariants.findIndex(item=>item.id===variant?.id);
      if(index<0)return;
      let target=index+(this.previewVariants.length>1?1:0);
      if(animate && this.previewVariants.length>1){
        const position=this.slides.scrollLeft;
        this.slideVariants.forEach((item,i)=>{
          if(item.id===variant.id && Math.abs(this.panels[i].offsetLeft-position)<Math.abs(this.panels[target].offsetLeft-position))target=i;
        });
      }
      this.goToSlide(target,animate);
      this.panels.forEach((panel,i)=>panel.setAttribute('aria-hidden',String(i!==target)));
    }
    scheduleSettle() {
      clearTimeout(this.settleTimer);
      this.settleTimer=setTimeout(()=>this.settleSlide(),180);
    }
    alignSlides() {
      this.slideWidth=this.slides.clientWidth;
      clearTimeout(this.resizeTimer);
      this.resizing=true;
      if(this.dialog.open && this.slideWidth)this.showSlide(this.currentVariant,false);
      this.resizeTimer=setTimeout(()=>{
        if(this.dialog.open && this.slides.clientWidth){
          this.showSlide(this.currentVariant,false);
          this.revealOption();
        }
        this.resizing=false;
      },120);
    }
    settleSlide() {
      if(!this.dialog.open || this.touching || this.gesture || !this.slides.clientWidth)return;
      if(this.slides.clientWidth!==this.slideWidth){this.alignSlides();return;}
      if(this.resizing)return;
      const index=this.slideIndex();
      if(Math.abs(this.slides.scrollLeft-this.panels[index].offsetLeft)>2){this.scheduleSettle();return;}
      clearTimeout(this.settleTimer);
      const variant=this.slideVariants[index];
      if(!variant)return;
      let active=index;
      if(this.previewVariants.length>1 && (index===0 || index===this.panels.length-1)){
        active=index===0?this.previewVariants.length:1;
        this.goToSlide(active,false);
      }
      this.panels.forEach((panel,i)=>panel.setAttribute('aria-hidden',String(i!==active)));
      if(variant.id!==this.currentVariant?.id)this.selectVariant(variant,true);
    }
    stepVariant(direction) {
      if(this.previewVariants.length<2)return;
      const index=this.previewVariants.findIndex(variant=>String(variant.id)===String(this.currentVariant?.id));
      this.selectVariant(this.previewVariants[(index+direction+this.previewVariants.length)%this.previewVariants.length]);
    }
    selectVariant(variant,fromSlide=false) {
      if(!variant)return;
      const groups=Array.from(this.info.querySelectorAll('variant-picker select, variant-picker fieldset'));
      let changed;
      groups.forEach((group,index)=>{
        if(group.tagName==='SELECT'){
          if(group.value!==variant.options[index]){group.value=variant.options[index];changed=group;}
        }else{
          const input=Array.from(group.querySelectorAll('input[type="radio"]')).find(item=>item.value===variant.options[index]);
          if(input && !input.checked){input.checked=true;changed=input;}
        }
      });
      if(changed)changed.dispatchEvent(new Event('change',{bubbles:true}));
      this.openVariant(variant,fromSlide);
    }
    setVariant(variant,fromSlide=false) {
      if(!variant)return;
      const changed=variant.id!==this.currentVariant?.id;
      this.currentVariant=variant;
      this.frame.style.setProperty('--ss-style-aspect',Math.max(.2,Number(variant.ratio)||1));
      this.querySelector('[data-open]').hidden=!variant.url;
      this.querySelectorAll('[data-style]').forEach(span=>span.textContent=variant.title);
      this.querySelectorAll('[data-preview-variant]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.previewVariant===String(variant.id))));
      if(!variant.url){if(this.dialog.open)this.dialog.close();return;}
      if(changed && this.dialog.open && !fromSlide)this.showSlide(variant,true);
    }
    openVariant(variant,fromSlide=false) {
      if(!variant?.url)return;
      this.setVariant(variant,fromSlide);
      if(!this.dialog.open){
        this.dialog.showModal();
        this.dialog.scrollTop=0;
        document.documentElement.classList.add('ss-sku-preview-open');
        this.showSlide(variant,false);
      }
      this.revealOption();
    }
    revealOption() {
      requestAnimationFrame(()=>{
        if(!this.isConnected || !this.dialog.open)return;
        const active=this.options.querySelector('[aria-pressed="true"]');
        if(!active)return;
        const item=active.getBoundingClientRect();
        const rail=this.options.getBoundingClientRect();
        let offset=0;
        if(item.left<rail.left+4)offset=item.left-rail.left-4;
        else if(item.right>rail.right-4)offset=item.right-rail.right+4;
        if(offset)this.options.scrollTo({left:this.options.scrollLeft+offset,behavior:'auto'});
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.resizeObserver?.disconnect();
      clearTimeout(this.settleTimer);
      clearTimeout(this.resizeTimer);
      if(this.dialog?.open){this.dialog.close();document.documentElement.classList.remove('ss-sku-preview-open');}
      this.ready=false;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticksoo-style-strip"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('ss-style-strip'))return;
  customElements.define('ss-style-strip',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.rail=this.querySelector('[data-style-rail]');
      this.buttons=Array.from(this.querySelectorAll('[data-style-direction]'));
      this.controller=new AbortController();
      const listen={signal:this.controller.signal};
      this.schedule=()=>{
        if(this.frame)return;
        this.frame=requestAnimationFrame(()=>{this.frame=null;this.updateStacks();});
      };
      this.rail.addEventListener('scroll',this.schedule,{...listen,passive:true});
      this.rail.addEventListener('scrollend',this.schedule,listen);
      this.buttons.forEach(button=>button.addEventListener('click',()=>this.page(Number(button.dataset.styleDirection)),listen));
      this.addEventListener('click',event=>{
        if(performance.now()<(this.blockClickUntil||0)){
          event.preventDefault();event.stopImmediatePropagation();
        }
      },{...listen,capture:true});
      this.rail.addEventListener('pointerdown',event=>{
        if(!event.isPrimary || event.button!==0)return;
        this.gesture={id:event.pointerId,type:event.pointerType,x:event.clientX,y:event.clientY,left:this.rail.scrollLeft,moved:false};
      },listen);
      this.rail.addEventListener('pointermove',event=>{
        const gesture=this.gesture;
        if(!gesture || gesture.id!==event.pointerId)return;
        const dx=event.clientX-gesture.x;
        if(Math.abs(dx)>7 && Math.abs(dx)>Math.abs(event.clientY-gesture.y)){
          gesture.moved=true;
          this.blockClickUntil=performance.now()+350;
          if(gesture.type==='mouse'){
            this.rail.setPointerCapture(event.pointerId);
            this.classList.add('is-dragging');
          }
        }
        if(gesture.moved && gesture.type==='mouse'){
          event.preventDefault();
          this.rail.scrollLeft=gesture.left-dx;
        }
      },listen);
      const endGesture=event=>{
        const gesture=this.gesture;
        if(!gesture || gesture.id!==event.pointerId)return;
        if(gesture.moved)this.blockClickUntil=performance.now()+350;
        this.gesture=null;
        this.classList.remove('is-dragging');
        if(this.rail.hasPointerCapture(event.pointerId))this.rail.releasePointerCapture(event.pointerId);
        this.schedule();
      };
      this.rail.addEventListener('pointerup',endGesture,listen);
      this.rail.addEventListener('pointercancel',endGesture,listen);
      this.rail.addEventListener('lostpointercapture',endGesture,listen);
      this.rail.addEventListener('dragstart',event=>event.preventDefault(),listen);
      this.rail.addEventListener('focusin',event=>{
        if(event.target.matches('input[type="radio"]'))this.reveal(event.target,false);
      },listen);
      this.rail.addEventListener('change',event=>{
        if(event.target.matches('input[type="radio"]'))this.reveal(event.target,true);
      },listen);
      this.resizeObserver=new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.rail);
      this.mutationObserver=new MutationObserver(this.schedule);
      this.mutationObserver.observe(this.rail,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','checked']});
      this.schedule();
      requestAnimationFrame(()=>{
        if(!this.isConnected)return;
        const checked=this.rail.querySelector('input:checked');
        if(checked)this.reveal(checked,false);
      });
    }
    items(){return Array.from(this.rail.children).filter(item=>!item.hidden);}
    updateStacks(){
      const items=this.items();
      const box=this.rail.getBoundingClientRect();
      const left=Math.max(0,this.rail.scrollLeft);
      const max=Math.max(0,this.rail.scrollWidth-this.rail.clientWidth);
      const width=parseFloat(getComputedStyle(this).getPropertyValue('--ss-stack-width'))||72;
      this.buttons.forEach(button=>{
        const previous=Number(button.dataset.styleDirection)<0;
        const visible=items.length>1 && (previous?left>3:max-left>3);
        if(!visible && button.contains(document.activeElement))this.rail.focus({preventScroll:true});
        button.hidden=!visible;
        if(!visible)return;
        const hidden=items.filter(item=>previous?item.getBoundingClientRect().left<box.left+width:item.getBoundingClientRect().right>box.right-width);
        const previews=previous?hidden.slice(-3).reverse():hidden.slice(0,3);
        button.querySelectorAll('.ss-style-stack-card').forEach((card,index)=>{
          const item=previews[index];
          const label=item?.querySelector('label');
          const picture=label?.style.getPropertyValue('--swatch-background-image')||'none';
          if(card.style.backgroundImage!==picture)card.style.backgroundImage=picture;
          card.style.visibility=item?'visible':'hidden';
        });
      });
    }
    move(left,animate){
      const max=Math.max(0,this.rail.scrollWidth-this.rail.clientWidth);
      this.rail.scrollTo({left:Math.max(0,Math.min(max,left)),behavior:animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
    }
    page(direction){
      const size=parseFloat(getComputedStyle(this).getPropertyValue('--ss-style-size'))||52;
      const gap=parseFloat(getComputedStyle(this).getPropertyValue('--ss-style-gap'))||9;
      const count=Math.max(1,Math.floor((this.rail.clientWidth-130)/(size+gap)));
      this.move(this.rail.scrollLeft+direction*count*(size+gap),true);
    }
    reveal(input,animate){
      const item=input.closest('li');
      if(!item)return;
      const items=this.items();
      if(item===items[0]){this.move(0,animate);return;}
      if(item===items[items.length-1]){this.move(this.rail.scrollWidth,animate);return;}
      const box=this.rail.getBoundingClientRect();
      const rect=item.getBoundingClientRect();
      const padding=parseFloat(getComputedStyle(this).getPropertyValue('--ss-stack-width'))+6;
      const left=this.rail.scrollLeft;
      const max=this.rail.scrollWidth-this.rail.clientWidth;
      const start=box.left+(left>3?padding:4);
      const end=box.right+(max-left>3?-padding:-4);
      if(rect.left<start || rect.right>end)this.move(left+rect.left-box.left-(box.width-rect.width)/2,animate);
    }
    disconnectedCallback(){
      this.controller?.abort();this.controller=null;
      this.resizeObserver?.disconnect();this.mutationObserver?.disconnect();
      if(this.frame)cancelAnimationFrame(this.frame);
      this.frame=null;this.gesture=null;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
